import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Reveal } from '../ui/Reveal';
import { StructureVisual, type StructureKind } from '../visuals/StructureVisual';
const kinds: StructureKind[] = ['strategy', 'content', 'system', 'analysis'];
export function Structure() {
  const {
    t
  } = useLanguage();
  return <section id="estructura" className="bg-canvas py-28 md:py-40" data-id="element-217" data-mp="3sr1dipfac7tj">
      <div className="mx-auto max-w-6xl px-5 md:px-6" data-id="element-218" data-mp="3505d53wrk4ao">
        <Reveal data-id="element-219" data-mp="3531deyw3352a">
          <h2 className="text-center text-5xl font-semibold leading-[1.02] tracking-[-0.035em] text-graphite md:text-7xl" data-id="element-220" data-mp="301vjixqotbr6">
            {t.structure.title}
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-4 md:mt-20 md:grid-cols-2 md:gap-5" data-id="element-221" data-mp="3ewrydtt04xd8">
          {t.structure.items.map((item, i) => {
          const isSystem = kinds[i] === 'system';
          return <Reveal key={kinds[i]} delay={i * 0.05} data-id="element-222" data-mp="uaqf0lhb081w" data-mpi={i}>
                <div className={`flex min-h-[380px] flex-col rounded-[28px] p-8 md:min-h-[460px] md:p-10 ${isSystem ? 'bg-ink' : 'bg-white'}`} data-id="element-223" data-mp="p90zotn1t880">
                  <div className="grid flex-1 place-items-center" data-id="element-224" data-mp="2bueph4qtqivc">
                    <StructureVisual kind={kinds[i]} data-id="element-225" data-mp="2guavf9j30kdj" />
                  </div>
                  <div className="mt-8" data-id="element-226" data-mp="2gs6gzxnk42z0">
                    <div className={`text-xs font-medium tracking-[0.2em] ${isSystem ? 'text-muted' : 'text-subtle'}`} data-id="element-227" data-mp="2kwe79z9nxqzc">
                      {item.title}
                    </div>
                    <div className={`mt-2 text-4xl font-semibold tracking-[-0.03em] md:text-5xl ${isSystem ? 'text-white' : 'text-graphite'}`} data-id="element-228" data-mp="1t5hvz3393ue6">
                      {item.word}
                    </div>
                  </div>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}